export default (string) => {
  if (string) {
    return string.replace(/_/g, ' ')
  }

  return null
}
